import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { MobileAppVersionResponseModel } from '@shared/models/mobile-app-version.model';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  private readonly http = inject(HttpClient);

  isAppVersionCompatible(): Observable<boolean> {
    if (!environment.mobileApp?.isMobileApp) return of(true);

    return this.http
      .get<MobileAppVersionResponseModel>(environment.mobileApp.appVersionUrl)
      .pipe(switchMap((data) => of(data.minSupportedReleaseVersion === environment.mobileApp?.minSupportedReleaseVersion)));
  }
}
